import React, { useEffect, useState } from 'react';

const images = {
  "Italiana": require('../assets/Italiana.jpg'),
  "Rock / Pop": require('../assets/Rock - Pop.jpg'),
  "Hard Rock / Metal": require('../assets/Hard Rock - Metal.jpg'),
  "Punk / New Wave": require('../assets/Punk - New Wave.jpg'),
  "Elettronica / Mix": require('../assets/Elettronica - Mix.jpg'),
  "Jazz": require('../assets/Jazz.jpg'),
  "Funk / Soul": require('../assets/Funk - Soul.jpg'),
  "World / Afro / Latin": require('../assets/World - Afro - Latin.jpg'),
  "Reggae": require('../assets/Reggae.jpg'),
  "Hip Hop / Rap": require('../assets/Hip Hop - Rap.jpg'),
  "Colonne sonore": require('../assets/Colonne sonore.jpg'),
  "Classica": require('../assets/Classica.jpg'),
  "Various": require('../assets/Various.jpg'),
  "Non Music": require('../assets/Non Music.jpg'),
  "Vinili 33": require('../assets/Vinili 33.png'),
  "Vinili 45": require('../assets/Vinili 45.png'),
  "DVD": require('../assets/DVD.png'),
  "Musicassette": require('../assets/Musicassette.png'),
  "CD": require('../assets/CD.png'),
};


export default function CachedImage({ source, style, alt }) {
  const [cachedSource, setCachedSource] = useState(null);

  function getImageFilePath() {
    if (window.appData.tipoProdotto.includes(source) || window.appData.generiMusicali.includes(source)) {
      return images[source];
    } else {
      return null;
    }
  }

  function createImageURL(filePath) {
    return new Promise((resolve, reject) => {
      fetch(filePath)
        .then(response => {
          if (!response.ok) {
            throw new Error('Failed to fetch file');
          }
          return response.blob();
        })
        .then(blob => {
          const reader = new FileReader();
          reader.onload = () => {
            const dataURL = reader.result;
            resolve(dataURL);
          };
          reader.onerror = error => {
            reject(error);
          };
          reader.readAsDataURL(blob);
        })
        .catch(error => reject(error));
    });
  }

  useEffect(() => {
    const fetchAndCacheImage = async () => {
      try {
        const cachedImage = localStorage.getItem(source);
        if (cachedImage) {
          setCachedSource(cachedImage);
        } else {

          const filePath = getImageFilePath();

          createImageURL(filePath)
            .then(dataURL => {
              //console.log('Data URL:', dataURL);
              localStorage.setItem(source, dataURL);
              setCachedSource(dataURL);
            })
            .catch(error => {
              console.error('Failed to load image:', error);
            });
        }
      } catch (error) {
        console.error('Error caching image:', error);
      }
    };

    fetchAndCacheImage();
  }, [source]);

  return <img src={cachedSource} style={style} alt={alt} />;
};

